import { useState } from 'react';
import {
  SimultaneousEntranceLimitType,
  simultaneousEntranceLimitTypeOptions,
  startEditorText,
} from './EntranceLimitForm.constants';
import { StyledRadioList, StyledFormField } from './EntranceLimitForm.styled';
import { EntranceLimitInput } from './EntranceLimitInput';

type SimultaneousLimitInputProps = {
  onSimultaneousLimitUpdate: (simultaneousLimit: number | null) => void;
  simultaneousLimit: number | null;
  error?: string;
  isReadOnly?: boolean;
};

export const SimultaneousLimitInput = (props: SimultaneousLimitInputProps) => {
  let initialLimitType = SimultaneousEntranceLimitType.unlimited;
  if (props.simultaneousLimit) {
    initialLimitType =
      props.simultaneousLimit === 1
        ? SimultaneousEntranceLimitType.one
        : SimultaneousEntranceLimitType.custom;
  }
  const [simultaneousLimitType, setSimultaneousLimitType] = useState(initialLimitType);

  const handleTypeSelect = (type: SimultaneousEntranceLimitType) => {
    setSimultaneousLimitType(type);
    if (type === SimultaneousEntranceLimitType.one) {
      props.onSimultaneousLimitUpdate(1);
    } else {
      props.onSimultaneousLimitUpdate(null);
    }
  };

  return (
    <StyledFormField
      labelText={startEditorText.simultaneousHeading}
      descriptionText={startEditorText.simultaneousDescription}
      hasError={!!props.error}
      errorText={props.error}
    >
      <StyledRadioList
        onSelect={handleTypeSelect}
        options={simultaneousEntranceLimitTypeOptions.map((opt) => ({
          ...opt,
          isDisabled: props.isReadOnly,
        }))}
        value={simultaneousLimitType}
        name="simultaneous-limit-input"
      />
      {simultaneousLimitType === SimultaneousEntranceLimitType.custom && (
        <EntranceLimitInput
          inputId="simultaneous-limit-input"
          testId="simultaneous-limit-input"
          onChange={props.onSimultaneousLimitUpdate}
          value={props.simultaneousLimit}
          isDisabled={props.isReadOnly}
        />
      )}
    </StyledFormField>
  );
};
